import React from 'react';

import { styled } from '@mui/system';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import useMarketedPromotions from 'bento-ordering/promotions/hooks/useMarketedPromotions';
import PromotionCard, {
  HORIZONTAL,
  VERTICAL
} from 'bento-ordering/promotions/components/PromotionsCard';
import PromotionCardSlider from 'bento-ordering/promotions/components/PromotionCardSlider';
import { useIsMobile, useIsTablet } from 'styles/hooks/mediaQueries';

export const PROMO_CARD_ROW_HORIZONTAL_MARGIN = 16;

const StyledGrid = styled(Grid)({
  paddingTop: '34px'
});

const StyledGridItem = styled(Grid)({
  flexGrow: 1,
  flexBasis: 'min-content'
});

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  position: 'relative',
  margin: '16px 0 0',
  '& .overlay': {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    boxShadow: `inset 24px 0px 15px -24px rgba(0, 0, 0, 0.1), 
                inset -24px 0px 15px -24px rgba(0, 0, 0, 0.1)`,
    pointerEvents: 'none', // so the shadow overlay does not affect user clicking the promo card below
    zIndex: 20
  }
}));

function PromotionCardRow() {
  const promotions = useMarketedPromotions();
  const promotionsListLength = promotions.length;
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  if (promotionsListLength === 0) {
    return null;
  }
  const shouldRenderPromoSlider =
    (isMobile && promotionsListLength > 1) ||
    (isTablet && promotionsListLength > 2) ||
    promotionsListLength > 3;

  if (shouldRenderPromoSlider) {
    return (
      <StyledBox>
        <div className="overlay"></div>
        <PromotionCardSlider
          promotions={promotions}
          isMobile={isMobile}
          isTablet={isTablet}
        />
      </StyledBox>
    );
  }

  const cardContentOrientation =
    promotions.length === 1 ? HORIZONTAL : VERTICAL;

  /**
   * With externally linked promotions diners can have access to more than three promotions
   * however on desktop we only want to display the first three promotions.
   */
  const desktopPromotions = promotions.slice(0, 3);

  return (
    <StyledGrid
      spacing={2}
      container
      data-testid="promotion-card-container"
      promotionsListLength={promotionsListLength}
    >
      {desktopPromotions.map(promotion => (
        <StyledGridItem item key={promotion.id}>
          <PromotionCard
            promotion={promotion}
            cardContentOrientation={cardContentOrientation}
          />
        </StyledGridItem>
      ))}
    </StyledGrid>
  );
}

export default PromotionCardRow;
